import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=c3654864&scoped=true&"
import script from "./TermsOfService.vue?vue&type=script&lang=js&"
export * from "./TermsOfService.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=c3654864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3654864",
  null
  
)

export default component.exports